"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const SocialInstagram = createSVGIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3 6.5A4.5 4.5 0 0 1 7.5 2h10A4.5 4.5 0 0 1 22 6.5v10a4.5 4.5 0 0 1-4.5 4.5h-10A4.5 4.5 0 0 1 3 16.5zM7.5 3A3.5 3.5 0 0 0 4 6.5v10A3.5 3.5 0 0 0 7.5 20h10a3.5 3.5 0 0 0 3.5-3.5v-10A3.5 3.5 0 0 0 17.5 3zm.5 8.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM12.5 8a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm5-2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
    fill="#333"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "SocialInstagram",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Instagram",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
  })
);
